<template>
    <template-layout fullheader="true">
        <template slot="header">
            <div class="container">
                <div class="columns">
                    <div class="column">
                    </div>

                    <div class="column is-one-third">
                        <!-- Email sent -->
                        <div v-if="success == true" class="box">
                            <h1 class="title">Revisá tu correo</h1>

                            <p>Te enviamos un email para verificar tu dirección. Seguí los pasos en el mail.</p>
                        </div>

                        <!-- Registration form -->
                        <div v-else class="box">
                            <h1 class="title">Crear Cuenta</h1>
                            <p>Completá los siguientes datos para empezar.</p>

                            <form action="/api/login">
                                <b-field label="Nombre" expanded :type="errors.has('firstName') ? 'is-danger' : ''" :message="errors.first('firstName')">
                                    <b-input name="firstName" v-model="firstName" v-validate="'required'"></b-input>
                                </b-field>

                                <b-field label="Apellido" expanded :type="errors.has('lastName') ? 'is-danger' : ''" :message="errors.first('lastName')">
                                    <b-input name="lastName" v-model="lastName" v-validate="'required'"></b-input>
                                </b-field>

                                <b-field label="Email" expanded :type="errors.has('email') ? 'is-danger' : ''" :message="errors.first('email')">
                                    <b-input name="email" v-model="email" v-validate="'required'"></b-input>
                                </b-field>

                                <b-field label="Contraseña" expanded :type="errors.has('password') ? 'is-danger' : ''" :message="errors.first('password')">
                                    <b-input ref="password" name="password" type="password" v-model="password" v-validate="'required'"></b-input>
                                </b-field>

                                <b-field label="Repetir contraseña" expanded :type="errors.has('password2') ? 'is-danger' : ''" :message="errors.first('password2')">
                                    <b-input name="password2" type="password" v-model="password2" v-validate="'required|confirmed:password'"></b-input>
                                </b-field>

                                <button class="button is-primary" :class="{ 'is-loading': isLoading }" v-on:click.prevent="onRegister">Continuar</button>
                            </form>
                        </div>
                    </div>

                    <div class="column">
                    </div>
                </div>
            </div>
        </template>
    </template-layout>
</template>

<script>
    import TemplateLayout from '../layout/TemplateLayout.vue';

    export default {
        name: 'register',
        data() {
            return {
                isLoading: false,
                success: false,

                firstName: '',
                lastName: '',
                email: '',
                password: '',
                password2: ''
            }
        },
        components: {
            TemplateLayout
        },
        methods: {
            onRegister: function(/*e*/) {
                this.errors.clear();

                return this.$validator.validate().then(result => {
                    this.isLoading = false;

                    if(!result)
                        throw new Error();

                    this.isLoading = true;

                    return this.$api.register({
                        firstName: this.firstName.trim(),
                        lastName: this.lastName.trim(),
                        email: this.email.trim(),
                        password: this.password.trim()
                    });
                }).then((/*response*/) => {
                    this.success = true;
                }).catch((error) => {
                    this.isLoading = false;

                    if(error.code === 'error.user.password_invalid') {
                        this.errors.add({ field: 'password', msg: this.$t(error.code) });
                    }
                    else if(error.code === 'error.request.invalid') {
                        Object.keys(error.errors).forEach((key) => {
                            let value = error.errors[key];
                            this.errors.add({ field: key, msg: this.$t(value) });
                        });
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header {
        background-size: cover;
        background-position-y: top;
    }

    footer {
        margin: 0;
    }
</style>